module["exports"] = [
  "縣",
  "市"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_TW/address/city_suffix.js
 ** module id = 1197
 ** module chunks = 0
 **/